import React from 'react';
import { parseRichText } from './richText';

function renderNodes(nodes, keyPrefix) {
  return nodes.map((node, index) => {
    const key = `${keyPrefix}-${index}`;
    switch (node.type) {
      case 'bold':
        return <strong key={key}>{renderNodes(node.children, key)}</strong>;
      case 'italic':
        return <em key={key}>{renderNodes(node.children, key)}</em>;
      case 'link':
        return (
          <a key={key} href={node.url} target="_blank" rel="noopener noreferrer nofollow ugc">
            {renderNodes(node.children, key)}
          </a>
        );
      case 'image':
        return <img key={key} className="rt-image" src={node.url} alt="" loading="lazy" />;
      default:
        return node.text;
    }
  });
}

// Shows a description exactly as it was written: every line, blank line and
// space, plus bold, italic, centred lines, links and uploaded images.
export default function FormattedText({ text, className = '' }) {
  const lines = parseRichText(text);
  return (
    <div className={`rich-text ${className}`.trim()}>
      {lines.map((line, index) => (
        <div
          key={index}
          className="rt-line"
          style={line.centre ? { textAlign: 'center' } : undefined}
        >
          {line.nodes.length ? renderNodes(line.nodes, String(index)) : ' '}
        </div>
      ))}
    </div>
  );
}
